module.exports = __webpack_public_path__ + "static/media/12.894856e9.jpg";